import React from 'react'
import { WemoloIcon } from '../../assets/icons'
import { useStyletron } from '../../theme'
import { LanguageSelectOptions, Dropdown } from '../Dropdown'
import {
    AdditionalLinksWrapper,
    BottomWrapper,
    Container,
    CopyrightText,
    DropdownWrapper,
    LinksWrapper
} from './Footer.style'
import { Link } from 'react-router-dom'

export type FooterLink =
    | {
          label: string
          to: string
          clicked?: never // Ensures 'clicked' cannot be present when 'to' is
      }
    | {
          label: string
          to?: never // Ensures 'to' cannot be present when 'clicked' is
          clicked: () => void
      }
export interface FooterProps {
    links?: Array<FooterLink>
    selectedLanguage?: string
    onLanguageChange?: (value: string) => void
    languages?: Array<{ label: React.ReactNode; id: string }>
    additionalLinks?: Array<FooterLink>
}

export const Footer = ({
    links,
    onLanguageChange,
    selectedLanguage,
    languages = [...LanguageSelectOptions],
    additionalLinks
}: FooterProps) => {
    const [css, theme] = useStyletron()
    const mobileBreakpoint = 840
    const currentWidth = window.innerWidth
    const isViewPortMobile = currentWidth < mobileBreakpoint

    let selectedOptionIndex = selectedLanguage ? LanguageSelectOptions.findIndex((e) => e.id === selectedLanguage) : 0
    if (selectedOptionIndex === -1) selectedOptionIndex = 0

    const footerLinkStyle = css({
        color: 'white',
        fontWeight: 300,
        fontSize: '14px',
        fontFamily: 'Albert Sans',
        lineHeight: '19.6px',
        opacity: 0.7,
        marginTop: isViewPortMobile ? '14px' : '0px',
        marginRight: isViewPortMobile ? '1rem' : '3rem',
        textDecoration: 'none',
        ':hover': {
            opacity: 1,
            cursor: 'pointer'
        }
    })

    return (
        <Container>
            <div>
                <WemoloIcon $dark={false} />
            </div>
            <DropdownWrapper>
                <Dropdown
                    $dark={false}
                    options={languages}
                    value={{
                        value: LanguageSelectOptions[selectedOptionIndex].label,
                        id: LanguageSelectOptions[selectedOptionIndex].id
                    }}
                    onChange={(newValue) => onLanguageChange && onLanguageChange(newValue[0].id as string)}
                />
            </DropdownWrapper>

            {additionalLinks && additionalLinks.length > 0 && (
                <AdditionalLinksWrapper>
                    {additionalLinks.map((link) => (
                        <Link key={link.label} to={link.to || ''} className={footerLinkStyle}>
                            {link.label}
                        </Link>
                    ))}
                </AdditionalLinksWrapper>
            )}

            <BottomWrapper $isViewPortMobile={isViewPortMobile}>
                <CopyrightText>© 2024 Wemolo GmbH</CopyrightText>
                <LinksWrapper $isViewPortMobile={isViewPortMobile}>
                    {links?.map((link) =>
                        link.to ? (
                            <Link key={link.label} to={link.to} className={footerLinkStyle}>
                                {link.label}
                            </Link>
                        ) : (
                            <div key={link.label} onClick={link.clicked} className={footerLinkStyle}>
                                {link.label}
                            </div>
                        )
                    )}
                </LinksWrapper>
            </BottomWrapper>
        </Container>
    )
}
